var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZigzag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.235,
    height: 48.304,
    viewBox: "0 0 84.235 48.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44476",
    "data-name": "Path 44476",
    d: "M99.743,82.138c-.288-3.307.056-6.708-.078-10.027-.217-5.381-.938-10.743-1.059-16.127-2.95,2.677-5.561,5.744-8.559,8.368-3.386,2.963-7.243,5.841-10.114,9.317q-.821-11.991-1.581-23.992c-6.115,5.309-12.493,10.872-18.106,16.675L57.512,42.585C50.555,47.5,44.478,53.7,37.474,58.623c-.142-6.817-.932-13.853-.73-20.623C31.056,42.226,25.673,47.723,20.5,52.55",
    transform: "translate(-17.673 -36)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigzag);
export default __webpack_public_path__ + "static/media/zigzag.33a5a013b0d4228ea71a97b73c7eeda7.svg";
export { ForwardRef as ReactComponent };